import {Modal} from './types'
import {channelInviteModal} from '../actions/modal'
import {store} from '../store'

export const handleModal = (modal: Modal) => {
    switch (modal.name) {
        case 'ChannelInviteModal':
            store.dispatch(channelInviteModal({
                accessKey: (modal.params as Record<string, string>)?.access_key, // eslint-disable-line no-extra-parens
                show: true,
            }))
            break
        default:
    }
}
